// src/pages/OrgStructure.js
import React from 'react';
import chairmanPic from '../assets/images/founder.jpg';
import coFounderPic from '../assets/images/co-founder.JPG';
import mdPic from '../assets/images/md.jpg';
import financePic from '../assets/images/finance.jpg';
import hrPic from '../assets/images/store.jpg';
import supplyChainPic from '../assets/images/supplyChain.jpg';
import salesMarketingPic from '../assets/images/salesMarketing.png';
import store1 from '../assets/images/store1.jpg';
import itPic from '../assets/images/gk.jpg'; // Example for IT or support staff
import orgStructureImage from '../assets/images/NESIM Organization Structure.png';
import './OrgStructure.css';

function OrgStructure() {
  return (
    <div className="org-structure-page">
      <h1>Organizational Structure</h1>
      
      {/* Organization Structure Image Section */}
      <section className="org-image-section">
        <img
          src={orgStructureImage}
          alt="NESIM Organization Structure"
          className="org-structure-img"
        />
      </section>
      
      {/* Meet the Team (Pictures) */}
      <section className="meet-the-team">
        <h2>Meet the Team</h2>
        <div className="team-grid">
          {/* Founder: Simon Kihumba */}
          <div className="team-member">
            <img src={chairmanPic} alt="Founder & Director" />
            <h3>Founder & Director</h3>
            <h4>Simon Kihumba</h4>
            <p>Oversees strategic direction and fosters stable contacts with suppliers and customers.</p>
          </div>
          {/* Co-Founder: Nelly Kihumba */}
          <div className="team-member">
            <img src={coFounderPic} alt="Co-Founder" />
            <h3>Co-Founder</h3>
            <h4>Nelly Kihumba</h4>
            <p>Supports strategic planning and fosters key partnerships for growth.</p>
          </div>
          <div className="team-member">
            <img src={mdPic} alt="Managing Director" />
            <h3>Managing Director</h3>
            <h4>Dennis Kihumba</h4>
            <p>Central to driving operational excellence and leading day-to-day operations.</p>
          </div>
          <div className="team-member">
            <img src={itPic} alt="IT Support" />
            <h3>Director & Board Member</h3>
            <h4>Grace Kihumba</h4>
            <p>Provides critical technological infrastructure and administrative assistance.</p>
          </div>
          <div className="team-member">
            <img src={hrPic} alt="HR & Admin Manager" />
            <h3>Store Manager</h3>
            <h4>Daniel Kihumba</h4>
            <p>Oversees inventory control, ensures timely dispatch and receipt of brewing materials.</p>
          </div>
          <div className="team-member">
            <img src={financePic} alt="Finance Manager" />
            <h3>Chief Accountant</h3>
            <h4>Helen Murugi</h4>
            <p>Ensures robust financial controls and sustainability.</p>
          </div>
          <div className="team-member">
            <img src={supplyChainPic} alt="Supply Chain & Logistics Manager" />
            <h3>Supply Chain & Logistics</h3>
            <h4>Jackie Otieno</h4>
            <p>Ensures efficient procurement, inventory management, and timely delivery.</p>
          </div>
          <div className="team-member">
            <img src={salesMarketingPic} alt="Technical Sales & Marketing" />
            <h3>Technical Sales</h3>
            <h4>George Otinga</h4>
            <p>Dedicated to customer acquisition, market expansion, and delivering tailored solutions.</p>
          </div>
          <div className="team-member">
            <img src={store1} alt="Store Attendant" />
            <h3>Store Attendant</h3>
            <h4>Charles Juma</h4>
            <p>Supports efficient daily operations by keeping brewing products accessible and properly managed.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OrgStructure;
